'use strict';

const lmsLoginImport = require('./lmsLoginImport');
const canvasCourseAvailability = require('../canvas/canvasCourseAvailability');

(function () {
  var module = angular.module('client.components');

  controller.$inject = ['$scope', '$location', '$log', '$q', '$rootScope', 'User', 'UserDefaultInfo', 'PermissionConsts', 'userPermissions',
    'CourseModalFactory', 'CourseFactory', 'ModalService', 'googleService', 'canvasService', 'schoologyService', 'classlinkService',
    'cleverService', 'UserCodeFactory', 'UserCourses', 'tourService', '$window', '$sessionStorage'];

  function controller($scope, $location, $log, $q, $rootScope, User, UserDefaultInfo, PermissionConsts, userPermissions,
                      CourseModalFactory, CourseFactory, ModalService, googleService, canvasService, schoologyService, classlinkService,
                      cleverService, UserCodeFactory, UserCourses, tourService, $window, $sessionStorage) {

    var ctrl = this;
    ctrl.permissions = PermissionConsts;
    ctrl.addingClass = false;

    ctrl.canAddCourses = function () {
      return User.getSystemRole() === User.ROLE.TEACHER &&
        !userPermissions.hasPermission(ctrl.permissions.ui_disable_rostering);
    };

    function getGoogleClassroomCourses(user) {
      return googleService.getAvailableCourses(user);
    }

    function getCanvasCourses(user) {
      return canvasService.getAvailableCourses(user);
    }

    function getSchoologyCourses(user) {
      return schoologyService.getAvailableCourses(user);
    }

    function getCleverCourses(user) {
      return cleverService.getImportableClasses(user);
    }

    function userIsTeacher() {
      return User.getSystemRole() === User.ROLE.TEACHER;
    }

    function userIsAdmin() {
      return userPermissions.hasPermission(PermissionConsts.subscription_admin) ||
        userPermissions.hasPermission(PermissionConsts.school_admin) ||
        userPermissions.hasPermission(PermissionConsts.district_admin);
    }

    ctrl.checkAddCourse = function () {
      if (userIsTeacher() && !userIsAdmin()) {
        UserCourses.getCourses().then(function (courses) {
          if (courses.length === 0) {
            UserDefaultInfo.getUserInfo().then(function (userInfo) {
              if (!userInfo.gg4l_user && userInfo.active_tour_topic_id === 0) {
                return ctrl.addCourse(true);
              }
            });
          }
        });
      }
    };

    ctrl.addCourse = (isNewTeacher, proceedNoPermission) => {
      if (ctrl.addingClass) {
        return false;
      }

      $rootScope.$emit('new-class');

      ctrl.addingClass = true;
      return UserDefaultInfo.getUserInfo().then((userInfo) => {
        if (lmsLoginImport.getLoginImportProvider(userInfo) !== 'google' || proceedNoPermission) {
          return createClassAsUsual(userInfo, isNewTeacher);
        }
        return googleService.checkAndRequestClassroomPermission(userInfo, {
          message: 'In order to import classes from Google, you must provide Exploros access to your Google Classrooms. ' +
            'Would you like to give Exploros access to your classes?',
          beforeRedirect: () => {
            $sessionStorage['newGoogleClass'] = true;
          },
          onDecline: () => {
            ctrl.addingClass = false;
            ctrl.addCourse(isNewTeacher, true);
          }
        }).then((hasPermission) => {
          try {
            if (hasPermission || proceedNoPermission) {
              return createClassAsUsual(userInfo, isNewTeacher);
            }
            ctrl.addingClass = false;
          }
          catch (e) {
            $log.error("addingClass inner error", e);
          }
        }).catch((error) => {
          $log.error("error in addCourse:", error);
          return createClassAsUsual(userInfo, isNewTeacher);
        });
      });
    };

    function createClassAsUsual(userInfo, isNewTeacher) {
      const integration = lmsLoginImport.getLoginImportProvider(userInfo);

      var emptyGoogle = { courses: [], has_courses: false, lms_id: 0 };
      const emptyCanvas = {
        courses: [],
        fetched: false,
        hasCanvasCourses: false,
        loadFailed: false,
        partiallyLoaded: false
      };
      var emptySchoology = { courses: [], isSchoologyClassroomUser: false, lms_id: 0 };
      var emptyClasslink = { courses: [], isClassLinkClassroomUser: false };
      const emptyClever = { courses: [], isCleverClassroomUser: false, disabledMessage: null };

      var fetchPromise = integration
        ? (integration === 'google' ? getGoogleClassroomCourses(userInfo)
          : integration === 'canvas' ? getCanvasCourses(userInfo)
          : integration === 'schoology' ? getSchoologyCourses(userInfo)
          : integration === 'clever' ? getCleverCourses(userInfo)
          : classlinkService.getImportableClasses())
        : $q.when(null);

      return fetchPromise.then(function (result) {
        ctrl.addingClass = false;

        var googleClasses = emptyGoogle;
        var canvasClasses = emptyCanvas;
        var schoologyClasses = emptySchoology;
        var classlinkClasses = emptyClasslink;
        let cleverClasses = emptyClever;

        if (integration === 'google') googleClasses = result || emptyGoogle;
        else if (integration === 'canvas') canvasClasses = result || emptyCanvas;
        else if (integration === 'schoology') schoologyClasses = result || emptySchoology;
        else if (integration === 'clever') cleverClasses = result && result.courses ? result : emptyClever;
        else if (integration === 'classlink') {
          classlinkClasses = result && result.courses ? { courses: result.courses, isClassLinkClassroomUser: true } : emptyClasslink;
        }

        if (integration === 'canvas' && userInfo.canvas_user && isNewTeacher &&
            canvasCourseAvailability.hasAvailableCanvasCourses(canvasClasses)) {
          return addFromCanvas(canvasClasses);
        }

        tourService.gotoNextTourStep();

        // Call UI to add a new class (pass integration so modal can show "already imported all" only for fetched integration)
        CourseModalFactory.add(userInfo, googleClasses, canvasClasses, schoologyClasses, classlinkClasses, cleverClasses, integration).then((response) => {
          var newClassType = response.classType;

          if (newClassType === 'google') {
            return addFromGoogleClassroom(googleClasses);
          } else if (newClassType === 'canvas') {
            return addFromCanvas(canvasClasses);
          } else if (newClassType === 'schoology') {
            return addFromSchoology(schoologyClasses);
          } else if (newClassType === 'classlink') {
            return addFromClassLink(classlinkClasses);
          } else if (newClassType === 'clever') {
            return addFromClever(cleverClasses);
          } else {
            return addExplorosCourse(response.name);
          }
        });
      }).catch((error) => {
        $log.error("error in createClassAsUsual:", error);
      });
    }

    function addExplorosCourse(name) {
      var d = $q.defer();

      CourseModalFactory.courseDetails().then(function (courseDetailsData) {
        var params = {
          'teacher_user_id': User.getId(),
          'class_name': name,
          'students': [],
          'grade': courseDetailsData.grade,
          'subject': courseDetailsData.subject,
          'licenses': courseDetailsData.licenses
        };

        return CourseFactory.add(params);
      })
        .catch(function (error) {
          $log.error("failed to create class:", name, error);

          var errorMessage = (error && error.data && error.data.error && error.data.error.message) ||
                            (error && error.data && error.data.message) ||
                            (error && error.message) ||
                            'Failed to create class. Please try again.';

          ModalService.show({
            message: errorMessage,
            backdrop: 'static',
            buttons: [
              {
                title: 'Ok',
                click: '$hide();'
              }
            ]
          });

          return d.reject(error);
        });

      return d.promise;
    }

    function getClassDetails(course) {
      return CourseModalFactory.courseDetails().then(function (courseDetailsData) {
        course.grade = courseDetailsData.grade;
        course.subject = courseDetailsData.subject;
        course.licenses = courseDetailsData.licenses;
        return course;
      });
    }

    function getUserCode() {
      return UserCodeFactory.get({}, {'id': User.getId()})
        .$promise.then(function (response) {
          return response.code;
        });
    }

    function importGoogleClassroomCourse(googleCourse) {
      var d = $q.defer();

      googleCourse.googlePostAssignments = true;

      var settings = {
        google: {
          classroom: googleCourse
        }
      };

      // do not copy additional files
      if (googleCourse && googleCourse.teacherFolder) {
        delete googleCourse.teacherFolder;
      }
      if (googleCourse && googleCourse.courseMaterialSets) {
        delete googleCourse.courseMaterialSets;
      }

      var section = googleCourse.section || '';
      if (section) {
        section = " | " + section;
      }

      var googleCourseId = googleCourse.id;
      var params = {
        lms_id: -1,
        teacherId: User.getId(),
        group_name: googleCourse.name + section,
        settings: angular.toJson(settings),
        grade: googleCourse.grade,
        subject: googleCourse.subject,
        licenses: googleCourse.licenses
      };

      getUserCode()
        .then(function (code) {
          params.teacherCode = code;
        })
        .then(function () {
          googleService.importCourse(googleCourseId, params)
            .$promise.then(function (response) {
            d.resolve(response);
          }, function (error) {
            d.reject(error);
          });
        })
        .catch(function (error) {
          return d.reject(error);
        });

      return d.promise;
    }

    function classAdded(course) {
      var remove;
      // if this returned an error
      if (course && course.error && course.error.type) {
        if (course.error.type === "class_size") {
          CourseFactory.maxStudentsMsg().then(function (msg) {
            var maxStudentAlert = xpAlert.error(msg, true);
            remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
              remove();
              maxStudentAlert();
            });
          });
        } else {
          var closeAlert = xpAlert.error("An error occurred adding this class: " + course.message, true);
          remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
            remove();
            closeAlert();
          });
        }
      } else if (course && course.cid) {
        // Need to switch to the new class and display the success message.  After that, any switching should hide the message
        remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
          if (current &&
            current.$$route &&
            current.$$route.originalPath == '/class/:classId' &&
            current.pathParams &&
            current.pathParams.classId == course.cid) {
            remove();
            var addedCount = course.addedStudents || course.added || 0;
            var postFix = addedCount == 1 ? " student!" : " students!";
            if (course.failedStudents) {
              postFix = postFix + " " + course.failedStudents + " students couldn't be added.";
            }
            if (course.failedDomainStudents) {
              postFix = postFix + " " + course.failedDomainStudents + " students couldn't be added due to invalid e-mail domains.";
            }
            if (!course.sufficientSeats) {
              postFix = postFix + " Note that you exceeded your seat license limit. <a href=\"http://help.exploros.com/en/articles/4912771-seat-licenses-for-teachers\" target=blank> Learn more.</a>";
            }
            var close = xpAlert.success("You successfully imported a class with " + addedCount + postFix, true);

            remove = $rootScope.$on('$routeChangeSuccess', function (event, current, prev) {
              remove();
              close();
            });
          }
        });

        // Navigate to the class - for LMS imports, WebSocket notifications may not trigger navigation
        $location.path('/class/' + course.cid);
      }
    }

    function handleAddClassroomError(response) {
      $log.error("error in handling classroom:", response);
      var d = $q.defer();

      var params = {
        content: ''
      };

      var errors = [
        {
          error: 'NotGoogleAppsUser',
          content: 'Unable to access Google Classroom. Are you part of a Google Apps for Education domain?'
        },
        {
          error: 'ClassroomDisabled',
          message: 'Unable to access Google Classroom. Are you a Google Classroom user?'
        },
        {
          error: 'ClassroomApiDisabled',
          message: 'Unable to access Google Classroom. It appears the Google Classroom API is not configured properly on the server.'
        },
        {
          error: 'NoRefreshToken',
          message: 'You need additional authorization for Google Classroom. Click here to proceed.'
        }
      ];

      if (response && response.data && response.data.error && response.data.error.errors) {
        var errorResponse = response.data.error;
        errorResponse.errors.forEach(function (err) {
          errors.forEach(function (error) {
            if (~err.message.indexOf(error.error)) {
              params.content += error.message + '<br>';
            }
          });
        });
      }

      if (response.data && response.data.redirect) {
        params.callback = function () {
          $window.location.href = response.data.redirect;
        };
      }

      if (params.content.length > 0) {
        showErrorAlert(params);
      }

      return d.promise;
    }

    function addFromGoogleClassroom(googleClasses) {
      return CourseModalFactory.addFromGoogleClassroom(googleClasses)
        .then(getClassDetails)
        .then(importGoogleClassroomCourse)
        .then(function (course) {
          return classAdded(course);
        })
        .catch(handleAddClassroomError);
    }

    function getCanvasCourseWrapped(canvasCourse) {
      var course = {
        course: canvasCourse
      };

      return $q.when(course);
    }


    function importCanvasCourse(canvasCourse) {
      canvasCourse.course.canvasPostAssignments = true;

      var settings = {
        canvas: {
          classroom: canvasCourse.course
        }
      };

      var params = {
        lms_id: canvasCourse.course.lms_id,
        section_id: canvasCourse.course.section_id,
        teacherId: User.getId(),
        group_name: canvasCourse.course.name,
        students: angular.toJson(canvasCourse.students),
        settings: angular.toJson(settings),
        grade: canvasCourse.grade,
        subject: canvasCourse.subject,
        licenses: canvasCourse.licenses
      };

      return canvasService.importCourse(canvasCourse.course.course_id, params);
    }

    function addFromCanvas(canvasClasses) {
      return CourseModalFactory.addFromCanvas(canvasClasses)
        .then(getCanvasCourseWrapped)
        .then(getClassDetails)
        .then(importCanvasCourse)
        .then(function (course) {
          return classAdded(course);
        })
        .catch(handleAddClassroomError);
    }

    function getSchoologyWrapped(schoologyCourse) {
      var course = {
        course: schoologyCourse
      };

      return $q.when(course);
    }

    function importSchoologyCourse(schoologyCourse) {
      schoologyCourse.course.schoologyPostAssignments = true;

      var settings = {
        schoology: {
          classroom: schoologyCourse.course
        }
      };

      var params = {
        lms_id: schoologyCourse.course.lms_id,
        section_id: schoologyCourse.course.section_id,
        teacherId: User.getId(),
        group_name: schoologyCourse.course.name,
        students: angular.toJson(schoologyCourse.students),
        settings: angular.toJson(settings),
        grade: schoologyCourse.grade,
        subject: schoologyCourse.subject,
        licenses: schoologyCourse.licenses
      };

      return schoologyService.importCourse(schoologyCourse.course.course_id, params);
    }

    function addFromSchoology(schoologyClasses) {
      return CourseModalFactory.addFromSchoology(schoologyClasses)
        .then(getSchoologyWrapped)
        .then(getClassDetails)
        .then(importSchoologyCourse)
        .then(function (course) {
          return classAdded(course);
        })
        .catch(handleAddClassroomError);
    }

    function getClassLinkWrapped(classlinkCourse) {
      return $q.when({ course: classlinkCourse });
    }

    function importClassLinkCourse(courseWithDetails) {
      var params = {
        teacherId: User.getId(),
        grade: courseWithDetails.grade,
        subject: courseWithDetails.subject,
        licenses: courseWithDetails.licenses
      };
      return classlinkService.importCourse(courseWithDetails.course, params);
    }

    function addFromClassLink(classlinkClasses) {
      classlinkClasses = classlinkClasses || { courses: [] };
      if (!classlinkClasses.courses || !classlinkClasses.courses.length) {
        return $q.when();
      }
      return CourseModalFactory.addFromClassLink(classlinkClasses)
        .then(getClassLinkWrapped)
        .then(getClassDetails)
        .then(importClassLinkCourse)
        .then(function (course) {
          return classAdded(course);
        })
        .catch(function (err) {
          if (err && err.noClasses) { return; }
          return handleAddClassroomError(err);
        });
    }

    function getCleverWrapped(cleverCourse) {
      return $q.when({ course: cleverCourse });
    }

    function importCleverCourse(courseWithDetails) {
      const params = {
        teacherId: User.getId(),
        grade: courseWithDetails.grade,
        subject: courseWithDetails.subject,
        licenses: courseWithDetails.licenses
      };
      return cleverService.importCourse(courseWithDetails.course, params);
    }

    function addFromClever(cleverClasses) {
      cleverClasses = cleverClasses || { courses: [] };
      if (!cleverClasses.courses || !cleverClasses.courses.length) {
        return $q.when();
      }
      return CourseModalFactory.addFromClever(cleverClasses)
        .then(getCleverWrapped)
        .then(getClassDetails)
        .then(importCleverCourse)
        .then(function (course) {
          return classAdded(course);
        })
        .catch(function (err) {
          if (err && err.noClasses) { return; }
          return handleAddClassroomError(err);
        });
    }
  }

  module.component('newClass', {
    template: require('./newClass.jade'),
    controller: controller
  });

  module.component('noClass', {
    template: require('./noClass.jade'),
    controller: controller
  });

  module.component('googleClass', {
    template: require('./googleClass.jade'),
    controller: controller
  });

})();
